<template>
    <div class="page white_bg">

        <header class="pageHeader paddingH16 paddingV8 white_bg">
            <div class="borderLayout">
                <div class="middleRegion">
                    <div class="westRegion" style="width: 30px">
                        <router-link to="/" class="icon leftAngleBracketIcon floatL"
                             style="margin-top: 3px;"></router-link>
                    </div>
                    <div class="centerRegion alignCenter font18r primaryTextColor bold"
                         style="line-height: 30px; overflow: hidden">
                        {{title}}
                    </div>
                    <div class="eastRegion font14r alignRight" style="width: 30px"></div>
                </div>
            </div>
        </header>

        <div class="body">
            <div class="alignC" style="padding: 26px 0;">
                <img src="notice/submit_success.png" width="250" height="118"/>
            </div>
            <div style="padding: 0 30px;">
                亲爱的小主，您的分销资格已经申请通过咯，现在去进行下一步账号开通即可，您离我们的合伙人又近了一步，期待您的加入~
            </div>
            <div class="" style="padding: 0 37px; margin-top: 28px;">
                <router-link to="/" class="button block openButton">
                    立即开通
                </router-link>
            </div>
        </div><!-- end .body -->

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '@/appConfig';

// util and platformApi
import appHelper    from '@/util/appHelper';
import consoleApi   from '@/components/platformApi/consoleApi';

const config = {
    name : 'distributorOpen',
    title : '分销商开通',
    description : ''
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            title : config.title,
            description : config.description
        }
    }
}
</script>

<style lang="scss" scoped>
.openButton {
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    padding: 0;
    background: #F4950E;
    border: none;
    color: white;
}
</style>
